module.exports = __webpack_public_path__ + "assets/measure_vehicle_fuel_economy.a34e6cc8.svg";